import { BaseError } from "./error-base";

type ErrorName =
    | 'PERSONNEL_NOT_FOUND'
    | 'PERSONNEL_NOT_AUTHORIZED'
    | 'INVALID_USER_TYPE';

export class AuthorizationError extends BaseError<ErrorName> {}